<template>
  <div class="user-settings-container">
    <user-settings-menu />
  </div>
</template>

<script>
import UserSettingsMenu from '@/views/modules/user/user-settings-menu/UserSettingsMobileMenu.vue';

/**
 * User settings configurations and details
 *
 * @module views/modules/user-account/UserSettings
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'UserSettings',
  components: {
    UserSettingsMenu,
  },
};
</script>

<style lang="scss">
.user-settings-container {
  // Let the grid layout handle sizing
}
</style>
